import { Component, Input } from '@angular/core';

type UserBase = {
  logo?: {
    url: string;
  };
  firstName: string;
  lastName: string;
};
type EntityBase = {
  lastName?: string;
  users?: UserBase[];
  firstName?: string;
  isCompany?: boolean;
  companyname?: string;
};

export const COLORS_ORDERED = [
  '#0097A7',
  '#F57C00',
  '#48964C',
  '#48964C',
  '#C73C11',
  '#546E7A',
  '#358ABF',
  '#F89F48',
  '#849DBC',
  '#37474F',
];

const COMPANY_TEXT = 'company';
@Component({
  selector: 'orgbrain-letter-generic-avatar',
  templateUrl: './letter-avatar.component.html',
  styleUrls: ['./letter-avatar.component.scss'],
  standalone: false,
})
export class LetterAvatarGenericComponent {
  unknownName = 'ツ';
  isCompany = false;
  _firstName = '';
  _lastName = '';
  _initials = '';
  _logoUrl = '';
  superImageUrl: any;
  displayedText: string;
  @Input() size: number = 64;
  @Input() set logoUrl(value: string) {
    this._logoUrl = value;
  }
  @Input() set firstname(value) {
    this._firstName = value;
    this.makeAvatar();
  }
  @Input() set lastname(value) {
    this._lastName = value;
    this.makeAvatar();
  }

  @Input() set fullName(value) {
    const names = value.trim().split(' ');

    this._firstName = names?.[0] || '';
    this._lastName = names?.[names.length - 1] || '';
    this.makeAvatar();
  }

  @Input() set initials(value) {
    this._initials = this.processInitials(value);
    this.makeAvatar();
  }

  @Input() set entity(value: EntityBase) {
    this.processEntity(value);
    this.makeAvatar();
  }

  @Input() super: boolean;

  fillColor = 'grey';

  private processEntity(entity: EntityBase) {
    if (!entity) {
      this._initials = '';
    } else if (entity.isCompany) {
      this._initials = this.processInitials(entity.companyname || COMPANY_TEXT);
      this.isCompany = true;
    } else {
      this._initials = '';

      if (entity.firstName) {
        this._firstName = entity.firstName;
      } else if (entity.users?.length) {
        this._firstName = entity.users[0]?.firstName;
      }

      if (entity.lastName) {
        this._lastName = entity.lastName;
      } else if (entity.users?.length) {
        this._lastName = entity.users[0]?.lastName;
      }

      if (entity.users?.length) {
        this._logoUrl = entity.users[0]?.logo?.url;
      }
    }
  }

  private processInitials(val) {
    val = val || '';
    val = val.replace(/\s\s+/g, ' ').trim();
    if (val.includes(' ')) {
      const tokens = val.split(' ');
      val = tokens.reduce((result, current) => {
        if (!current) {
          return result;
        }
        return result + current[0];
      }, '');
    }
    this.isCompany = val === COMPANY_TEXT;
    return val.slice(0, 3);
  }

  setupInitials() {
    this._firstName = this._firstName || '';
    this._lastName = this._lastName || '';

    if (this._initials) {
      this.displayedText = this._initials.toUpperCase();
    } else {
      this.displayedText = this._firstName.charAt(0) + this._lastName.charAt(0);
      this.displayedText = this.displayedText.toUpperCase();

      if (!this.displayedText) {
        this.displayedText = this.unknownName;
      }
    }
  }

  setupColor() {
    const combinedString = this._firstName + this._lastName + this._initials;
    const sumOfAllLetters = combinedString
      .split('')
      .map((char) => char.charCodeAt(0))
      .reduce((a, b) => a + b, 0);
    this.fillColor = COLORS_ORDERED[sumOfAllLetters % COLORS_ORDERED.length];
    // const combinedString = this._firstName + this._lastName + this._initials;
    // const sumOfAllLetters = combinedString
    //   .split('')
    //   .map((char) => char.charCodeAt(0))
    //   .reduce((a, b) => a + b, 0);
    // // Base hue value for the color palette
    // const baseHue = sumOfAllLetters % 360; // 360 degrees for hue
    // const saturation = 35; // Set a fixed saturation for vibrancy
    // const lightness = 50; // Set a fixed lightness for a balanced brightness
    // // Create the HSL color string with the base hue, and fixed saturation and lightness
    // this.fillColor = `hsl(${baseHue}, ${saturation}%, ${lightness}%)`;
  }

  makeAvatar() {
    this.setupInitials();
    this.setupColor();
  }
}
